<template>
  <fragment>
     <Base :style="[styles]">
      <div class="wrapper">
        <iframe :src="`https://configurator.andtradition.com/en?iframe&family=${family}`" style="width: 100%; height: 700px;"
      frameborder="0" allowfullscreen allow="clipboard-write fullscreen"
      loading="lazy"></iframe>
      </div>
    </Base>
  </fragment>
</template>
<script>

import Base from './Base'
import utils from '@/mixins/utils'
export default {
  name: 'Button',

  mixins: [utils],

  components: {
    Base
  },
  extends: Base,

  props: {
    data: {
      type: Object,
      default: () => {
        return null
      }
    }
  },
  computed: {
    family() {
      return this.data.configurator.id || ''
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  @include grid-container;

  iframe {
    @include grid-item(12, 1);
  }
}
</style>
